import { gql } from 'apollo-boost'

const SCRAPING_TAGS_FOR_TEST_CASE = gql`
  query scrapingTagsForTestCaseId($testCaseId: ID!) {
    scrapingTagsForTestCaseId(testCaseId: $testCaseId) {
      id
      name
      type
    }
  }
`

export default SCRAPING_TAGS_FOR_TEST_CASE
